export default class StampCardState {
  stamps: any[] = [];
}
